import { render, staticRenderFns } from "./SettingsObjectives.vue?vue&type=template&id=de864084&scoped=true"
import script from "./SettingsObjectives.vue?vue&type=script&lang=js"
export * from "./SettingsObjectives.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de864084",
  null
  
)

export default component.exports